import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_ctx.itemsLength === 0)
    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
        default: _withCtx(() => [
          (_ctx.loading === false)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                "my-2": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    variant: "tonal",
                    class: "mx-auto border"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _renderSlot(_ctx.$slots, "description", {}, () => [
                                    _createTextVNode(" No ongoing tournaments at the moment... ")
                                  ])
                                ]),
                                _: 3
                              })
                            ]),
                            _: 3
                          })
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              }))
            : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_skeleton_loader, {
                        class: "mx-auto border",
                        type: "image"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}